import React from "react";
import {LocalizationProvider} from "@fluent/react";
import {SupportedLanguage} from "./constants";
import {localizationFor} from "./translator";

interface FluentProviderProps {
    lang: SupportedLanguage;
    children: React.ReactNode;
}

// Not keyed by language: a switch re-renders the context consumers, and the pages
// remount under LanguageBoundary — remounting the whole tree would re-run the app's
// one-time init (InitAppComponent) on every switch.
export const FluentProvider: React.FC<FluentProviderProps> = ({lang, children}) => (
    <LocalizationProvider l10n={localizationFor(lang)}>
        {children}
    </LocalizationProvider>
);
